<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="sm">
            <template #body>
                <div class="flex flex-col gap-2 px-2">
                    <label for="price">{{ $t('price') }}  (USD) </label>
                     <vs-input class="w-full" type="number" :placeholder="$t('price') | capitalize"  v-model="price" />
                </div>
                <div class="flex w-full mt-4">
                    <!-- Botón remover -->
                    <div class="flex justify-center items-center w-1/4 px-2">
                        <vs-button color="danger" icon="remove" @click="remove" :disabled="quantity <= 1">{{ $t('remove') }}</vs-button>
                    </div>

                    <!-- Input -->
                    <div class="flex justify-center items-center w-1/2 px-2">
                        <vs-input class="w-full" type="number" :placeholder="$t('amount') | capitalize" v-model="quantity" />
                    </div>

                    <!-- Botón agregar -->
                    <div class="flex justify-center items-center w-1/4 px-2">
                        <vs-button color="success" icon="add" @click="add">{{ $t('add') }}</vs-button>
                    </div>

                </div>
                <div class="flex flex-col gap-2 mt-4 px-2">
                    <label for="comments">{{ $t('comments') }}</label>
                    <vs-textarea class="w-full" v-model="comments"/>
                </div>

            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="submit" :disabled="isDisabled">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    pallets: { type: Object, default: () => ({ quantity: 0, price: 0 }) }
})

const emit = defineEmits(['click', 'submit', 'input'])

const quantity = ref('')
const comments = ref('')
const price = ref('')

watch(() => props.value, (newValue) => {
    if (newValue) {
        quantity.value = props.pallets.quantity
        price.value = props.pallets.price
        comments.value = ''
    }
})

const isDisabled = computed(() =>  quantity.value <= 0 || price.value <= 0 || comments.value == '' )

const add = () => {
    quantity.value++
}

const remove = () => {
    if (quantity.value > 1) {
        quantity.value--
    }
}

const close = () => {
    emit('input', false)
}

const submit = () => {
    emit('submit',{
        comments:comments.value,
        price:price.value,
        quantity:quantity.value
    })
}

</script>

<style></style>